import React from "react";
import { Bar } from "react-chartjs-2";

const VelocityChart = ({ data }) => {

  const chartData = {
    labels: data.map(d => d.sprint),
    datasets: [
      {
        label: "Velocity",
        data: data.map(d => d.velocity),
        backgroundColor: "#06b6d4"
      }
    ]
  };

  return (
    <div className="bg-gray-800 p-5 rounded-xl border border-gray-700">
      <h3 className="mb-4 font-semibold text-white">🚀 Sprint Velocity</h3>
      <Bar data={chartData}/>
    </div>
  );
};

export default VelocityChart;